module.exports = __webpack_public_path__ + "images/kihnu/android-icon-72x72.png";